import { cards } from '@/mocks/homeData';

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h3 className="text-xs tracking-widest uppercase text-primary-500 font-medium mb-2">Editorial Picks</h3>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950">编辑精选</h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-xl mx-auto">深度好文与观影指南，影视不止于观看</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {cards.slice(0, 3).map((card) => (
            <article key={card.id} className="bg-background-100 rounded-lg overflow-hidden border border-secondary-200/60 group cursor-pointer hover:border-primary-300/40 transition-colors flex flex-col">
              <div className="relative aspect-[3/2] overflow-hidden">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="text-xs bg-accent-500 text-background-50 px-2.5 py-0.5 rounded-full">
                    {card.category}
                  </span>
                </div>
              </div>
              <div className="p-5 flex-1 flex flex-col">
                <h3 className="text-base font-heading font-bold text-foreground-900 mb-2">{card.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed flex-1 mb-3">{card.desc}</p>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-foreground-400">{card.date}</span>
                  <span className="text-xs text-primary-500 font-medium flex items-center gap-1 cursor-pointer">
                    阅读更多 <i className="ri-arrow-right-line text-xs"></i>
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mt-6">
          {cards.slice(3, 5).map((card) => (
            <article key={card.id} className="bg-background-100 rounded-lg overflow-hidden border border-secondary-200/60 group cursor-pointer hover:border-primary-300/40 transition-colors flex flex-col sm:flex-row">
              <div className="relative sm:w-48 shrink-0 aspect-[16/10] sm:aspect-auto overflow-hidden">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              <div className="p-5 flex-1 flex flex-col justify-center">
                <span className="text-xs bg-secondary-200 text-secondary-700 px-2 py-0.5 rounded-full w-fit mb-2">
                  {card.category}
                </span>
                <h3 className="text-base font-heading font-bold text-foreground-900 mb-1">{card.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed mb-2">{card.desc}</p>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-foreground-400">{card.date}</span>
                  <span className="text-xs text-primary-500 font-medium flex items-center gap-1 cursor-pointer">
                    阅读更多 <i className="ri-arrow-right-line text-xs"></i>
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}